import React from 'react';
import { useNavigate } from 'react-router-dom';

export function HtmlContent({ children, as = 'span', ...props }) {
  const navigate = useNavigate();

  const handleClick = e => {
    const href = e.target.getAttribute('href');
    if (href && href.startsWith('/')) {
      e.preventDefault();
      navigate(href);
    }
  };

  return React.createElement(as, {
    ...props,
    onClick: handleClick,
    dangerouslySetInnerHTML: { __html: children }
  });
}
